import { LabelValueModel } from '../../../../../models/label-value.model';
import { ServerInitiatedTypeEnum } from '../enum/server-intiated-type.enum';

export const serverInitiatedTypes: LabelValueModel[] = [
  { label: 'None', value: ServerInitiatedTypeEnum.NONE },
  { label: 'Scheduled', value: ServerInitiatedTypeEnum.SCHEDULED },
  { label: 'Urgent', value: ServerInitiatedTypeEnum.URGENT },
];
